import usePossibleHospitalsOrPhysicians from '../usePossibleHospitalsOrPhysicians';

const usePossibleHospitals = usePossibleHospitalsOrPhysicians('hospitals');

export default usePossibleHospitals;
